import React, { useEffect } from 'react';
import SbEditable from 'storyblok-react';

const TemporaryRedirect = (props) => {
  useEffect(() => {
    if (typeof window !== undefined && props && props.blok && props.blok.uri) {
      window.location.href = props.blok.uri;
    }
  }, [props]);

  return (
    <SbEditable content={props.blok}>
      <div></div>
    </SbEditable>
  );
};

export default TemporaryRedirect;
